export default __webpack_public_path__ + "static/media/wi_8.f64c58d7.mp3";